import type { ActorDto } from '@newo/api-client';
import type { TQuestionStep } from '@/types/common';

export enum AgentCreationStep {
	SOURCE_SELECT = 'SOURCE_SELECT',
	TRAINING = 'TRAINING',
	SUCCESS = 'SUCCESS'
}

export enum AgentTrainingStep {
	Onboarding = 'Onboarding',
	CustomerCreation = 'CustomerCreation',
	ContactAgreement = 'ContactAgreement',
	Loading = 'Loading'
}

export enum TScrapingStatus {
	INITIAL = 'initial',
	STARTED = 'started',
	FINISHED = 'finished'
}

export type AgentTrainingStoreState = {
	actor: ActorDto | null;
	partner_idn: string | null;
	member_idn: string | null;

	step: AgentCreationStep;
	agentTrainingStep: AgentTrainingStep;

	hasUnreadNotification: boolean;
	scrapingStatus: TScrapingStatus;

	isCustomerFormAllowed: boolean;
	isContactFormAllowed: boolean;
	isModalOpenedFlag: boolean;

	isScrappingAnimationFinished: boolean;
	isScrappingSuccessAnimationFinished: boolean;

	isAgentProgressStepsVisible: boolean;
	agentSetupProgressStep: number;
	isNextButtonClicked: boolean;

	scrapingSteps: TQuestionStep[];

	isMiniModeExpanded: boolean;

	miniModeDragX: number | null;
};

export type AgentTrainingStoreActions = {
	setPartnerIdn: (partner_idn?: string | null) => void;
	setMemberIdn: (member_idn?: string | null) => void;

	setActor: (actor: ActorDto) => void;
	resetState: () => void;
	resetStatePreservePartner: () => void;

	setNotification: (val: boolean) => void;
	setIsNextButtonClicked: () => void;

	setAgentProgressStepsVisible: (isVisible: boolean) => void;
	incrementAgentProgressStep: (max: number) => void;
	setAgentProgressSteps: (count: number) => void;

	setScrapingStep: (
		step: TQuestionStep,
		initialLoadingCount: number,
		cols: number
	) => void;

	setIsContactFormAllowed: (value: boolean) => void;
	setShowCustomerForm: (isVisible: boolean) => void;
	setModalOpenedFlag: (isOpen: boolean) => void;

	setScrapingStatus: (value: TScrapingStatus) => void;
	setAgentStep: (step: AgentCreationStep) => void;
	setTrainingStep: (step: AgentTrainingStep) => void;

	setIsScrappingAnimationFinished: (value: boolean) => void;
	setIsScrappingSuccessAnimationFinished: (value: boolean) => void;

	toggleMiniExpanded: () => void;
	setMiniModeDragX: (x: number | null) => void;
};
